module.exports = __webpack_public_path__ + "img/ban1.9ffb3e28.jpg";